// extracted by mini-css-extract-plugin
export default {"logo":"Footer_logo__x26-B","social":"Footer_social__VzoVA"};